import { getUniqueIdentifier } from '@com-delta-idp/mnx-skymiles-shared';
import { HttpHeadersPayload, TrackJSConfig } from '@com-delta-idp/mnx-utils';

export const TRACKJSCONFIG = [
  {
    name: 'dvl1.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-skyclub'
  },
  {
    name: 'dvl2.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-skyclub'
  },
  {
    name: 'dvl3.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-skyclub'
  },
  {
    name: 'st.delta.com',
    token: '155b41f470444545829ee11dc1cb03ff',
    application: 'qat-skyclub'
  },
  {
    name: 'si.delta.com',
    token: '7749d424d31d404288ad07069d2775c9',
    application: 'si-skyclub'
  },
  {
    name: 'www.delta.com',
    token: '40c5d1df6a8049dfa571d3e4324bef72',
    application: 'www-skyclub'
  }
];

export const VALID_MEMBERSHIP_LEVELS: string[] = ['FO', 'PM', 'GM', 'DM'];

export const enum IDP_APPS {
  SKYCLUB = 'SKYCLUB',
  COMMON = 'COMMON'
}

export const enum EndpointKeys {
  SKYCLUB_AEM_URL = 'SKYCLUB_AEM_URL',
  PURCHASE_REQUEST_URL = 'PURCHASE_REQUEST_URL',
  SKY_CLUB_LOGIN_AUTH_CONFIG = 'SKY_CLUB_LOGIN_AUTH_CONFIG',
  ADD_TO_CART = 'ADD_TO_CART'
}

export enum HTTP_HEADERS {
  CONTENT_TYPE = 'application/json;',
  SKYCLUB = 'SKY_CLUB'
}

export const commonHeaderInfo: HttpHeadersPayload = {
  'Content-Type': HTTP_HEADERS.CONTENT_TYPE,
  transactionId: getUniqueIdentifier(),
  'x-api-key': HTTP_HEADERS.SKYCLUB
};

export const trackJsConfig: TrackJSConfig[] = [
  {
    name: 'dvl1.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-skyclub'
  },
  {
    name: 'dvl2.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-skyclub'
  },
  {
    name: 'dvl3.delta.com',
    token: 'aa519eae55f14ac4a298dd27a1f3dbdf',
    application: 'dvl-skyclub'
  },
  {
    name: 'st.delta.com',
    token: '155b41f470444545829ee11dc1cb03ff',
    application: 'qat-skyclub'
  },
  {
    name: 'si.delta.com',
    token: '7749d424d31d404288ad07069d2775c9',
    application: 'si-skyclub'
  },
  {
    name: 'www.delta.com',
    token: '40c5d1df6a8049dfa571d3e4324bef72',
    application: 'www-skyclub'
  }
];

export const MILES = ' miles';

export const CURRENCY = 'currency';

export const PURCHASE_CART_URL = '/purchase/cart';

export const REDIRECT = 'redirect';

export const CHECKOUT = 'checkout';

export const SKY_CLUB_ERROR = 'skyClubError';
